import { useState, useEffect } from 'react';
import { ModalBody } from 'reactstrap';
import { Headline, Paragraph, Link, List } from 'Common';
import { colors } from 'components/Theme';
import { bushLeft, balloonieSad, bushRight } from 'images/closing_popup';
import Style from './ClosingPopup.style';

const SESSION_KEY = 'balloon_closing_popup_dismissed';

const FAQ_URL = 'https://static.balloonapp.de/eob/FAQs_Balloon_Einstellung.pdf';

const ignoredRoutes = [
  '/krankenkasse/dak/sda',
  '/krankenkasse/dak',
  '/krankenkasse/dak-bgm',
  '/krankenkasse/techniker/sda',
  '/krankenkasse/techniker',
  '/krankenkasse/gothaer'
];

export const ClosingPopup = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    try {
      if (typeof sessionStorage !== 'undefined') {
        const dismissed = sessionStorage.getItem(SESSION_KEY);
        if (!dismissed && !ignoredRoutes.includes(window.location.pathname)) {
          setIsOpen(true);
        }
      }
    } catch {
      // ignore storage read failures
    }
  }, []);

  const handleClose = () => {
    try {
      if (typeof sessionStorage !== 'undefined') {
        sessionStorage.setItem(SESSION_KEY, 'true');
      }
    } catch {
      // ignore storage write failures
    }
    setIsOpen(false);
  };

  return (
    <Style isOpen={isOpen} toggle={handleClose} centered>
      <img src={bushLeft} alt="" className="bush bush-left" />
      <img src={bushRight} alt="" className="bush bush-right" />
      <ModalBody>
        <button className="close-btn" onClick={handleClose} aria-label="Popup schließen">
          <span aria-hidden="true">×</span>
        </button>
        <div className="content">
          <Headline level={2} textColor="white">
            Balloon wird eingestellt
          </Headline>
          <Paragraph textColor="white" className="ft">
            Wir bedanken uns für deine Treue und dafür, dass du die Balloon-App mit deiner Nutzung zu dem gemacht hast, was sie heute ist.
          </Paragraph>
          <Paragraph textColor="white" className="bold">
            Was bedeutet das für dich?
          </Paragraph>
        </div>
        <div className="list-wrapper">
          <List className="closing-list">
            {[
              'Du kannst deinen Zugriff noch bis 30.09.2026 nutzen.',
              'Nach dem 30.09.2026 wird der Betrieb für Nutzende mit Abo oder Einmalzahlung eingestellt.',
              <>
                Weitere Antworten auf deine Fragen findest du in diesem{' '}
                <Link
                  href={FAQ_URL}
                  color={colors.white.c500}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="FAQ als PDF herunterladen"
                >
                  FAQ
                </Link>
                .
              </>
            ]}
          </List>
        </div>
        <div className="illustration-wrapper">
          <img src={balloonieSad} alt="Trauriger Balloonie" className="balloonie" />
        </div>
      </ModalBody>
    </Style>
  );
};
